import {useNavigate, useParams, useLocation} from "react-router-dom";
import {useFirmwareGetQuery} from "../../app/api/api";
import QueryErrorAlert from "../../components/QueryErrorAlert";
import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import Page, {ContentTitle} from "../../components/Layout/Page";
import TabSection from "../../components/Layout/Page/TabSection";
import FirmwareGeneralTab from "./generalTab/FirmwareGeneralTab";
import {FirmwareField} from "../../app/api/model/firmware";

export default function FirmwareDetails() {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const firmwareId = parseInt(params.firmwareId || "");
    const {data: firmware, error} = useFirmwareGetQuery(firmwareId);
    const {t} = useTranslation();

    const initialTab = useMemo(() => {
        const fromHash = Number.parseInt((location.hash || "").replace("#", ""), 10);
        return Number.isFinite(fromHash) && fromHash >= 0 ? fromHash : 0;
    }, [location.hash]);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        navigate(`#${newValue}`, {replace: true});
    };

    if (error) {
        return <QueryErrorAlert error={error} />;
    }

    return (
        <Page>
            <ContentTitle
                titleKey="generic_firmware"
                subtitle={firmware?.[FirmwareField.VERSION_NUMBER]}
                entry={firmware}
                toolEntries={[
                    {
                        fieldName: FirmwareField.STATE,
                        translationKey: "firmware_state",
                    },
                    {
                        translationKey: "firmware_hardwareType",
                        fieldName: FirmwareField.HARDWARE_TYPE,
                    },
                    {
                        translationKey: "firmware_legacy",
                        fieldName: FirmwareField.LEGACY,
                        render: (value) => (value === true ? t("generic_yes") : t("generic_no")),
                    },
                ]}
            />
            <TabSection
                title={t("generic_devices")}
                initialTab={initialTab}
                onChange={handleTabChange}
                tabs={[
                    {label: t("generic_general"), content: firmware && <FirmwareGeneralTab firmware={firmware} />},
                    {
                        label: t("generic_history"),
                        content: t("generic_notAvailable"),
                    },
                ]}
            />
        </Page>
    );
}
